<div class="notification-banner-container">
  @for (banner of banners; track banner.id) {
    <div class="notification-banner border-{{ banner.iconColor }}"
         [@slideIn]
         (click)="onBannerClick(banner)">
      
      <!-- Icon -->
      <div class="banner-icon bg-{{ banner.iconColor }}">
        <i class="bx {{ banner.icon }}"></i>
      </div>

      <!-- Content -->
      <div class="banner-content">
        <div class="banner-title">{{ formatNotificationText(banner.title) }}</div>
        <div class="banner-message">{{ formatNotificationText(banner.message) }}</div>
      </div>

      <!-- Close button -->
      <button class="banner-close" (click)="onDismiss($event, banner)" aria-label="Dismiss">
        <i class="bx bx-x"></i>
      </button>

      <!-- Progress bar (auto-dismiss timer) -->
      <div class="banner-progress bg-{{ banner.iconColor }}"></div>
    </div>
  }
</div>
